





































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfirmDialog from "@/shared/ConfirmDialog.vue";
import { ICompany } from "../../companies/api/company.interface";
import { IStore } from "../../stores/api/store.interface";

@Component({
  name: "storeTable",
  components: {
    ConfirmDialog
  }
})
export default class StoreTable extends Vue {
  // Lifecycle Functions

  mounted(): void {}

  // Getters

  @Prop()
  stores: IStore[];

  @Getter("admin/companies")
  companies: ICompany[];

  // References
  $refs: {
    confirm: any;
  };

  headers: any[] = [
    {
      text: "Store",
      align: "left",
      sortable: true,
      value: "storeId"
    },
    {
      text: "Username",
      align: "center",
      sortable: "false",
      value: "storeUsername"
    },
    {
      text: "Cash Account",
      align: "center",
      sortable: "true",
      value: "cashAccountRef"
    },
    {
      text: "Charge Account",
      align: "center",
      sortable: "true",
      value: "creditAccountRef"
    },
    {
      text: "Company",
      align: "center",
      sortable: "true",
      value: "companyId"
    },
    {
      text: "Start Date",
      align: "center",
      sortable: "true",
      value: "startDate"
    },
    {
      text: "Auto Update",
      align: "center",
      sortable: "false",
      value: "autoUpdate"
    },
    {
      text: "Actions",
      align: "center",
      sortable: false,
      value: "storeId"
    }
  ];

  deleteStore(store: IStore): void {
    this.$refs.confirm
      .open(
        "Are you sure?",
        "Deleting this store will also delete all associated data and cannot be reversed.",
        {
          color: "red"
        }
      )
      .then((confirm: boolean) => {
        if (confirm) {
          this.$store.dispatch("admin/deleteStore", store.id);
        }
      });
  }

  // Helper functions

  companyFromId(id: number): string {
    var company: ICompany[] = this.companies.filter((obj: ICompany) => {
      return obj.id == id;
    });

    if (company.length > 0) return company[0].name;

    return "";
  }
}
